import { Select } from '../../../components/ui';
import type { FieldControlProps } from '../../../components/ui';
import { useT } from '../../../i18n';
import { useLuaChonModelAi } from '../../ai-model/hooks/useAiModels';

/** Giá trị đại diện cho "model mặc định của tổ chức" (`null` ở API) — `Select` không giữ được `null`. */
const MAC_DINH = '';

/**
 * Ô chọn model AI cho loại chứng từ, lọc theo vai: `dien` (điền dữ liệu, `can_map`) hay `doc`
 * (đọc chữ từng trang, `can_read_pages`). Vai `dien` có thêm lựa chọn "model mặc định"; vai `doc`
 * bắt buộc chọn. Model đã gán mà nay tắt hoặc không còn vẫn hiện bằng khoá để người dùng thấy và đổi.
 */
export function ChonModel({
  vai,
  value,
  onChange,
  ...p
}: {
  vai: 'dien' | 'doc';
  value: string | null;
  onChange: (v: string | null) => void;
  disabled?: boolean;
} & Partial<FieldControlProps>) {
  const { t } = useT();
  const q = useLuaChonModelAi();
  const hop = (q.data ?? []).filter((m) => (vai === 'dien' ? m.can_map : m.can_read_pages));
  const options = [
    ...(vai === 'dien' ? [{ value: MAC_DINH, label: t('ocr.modelMacDinh') }] : []),
    ...hop.map((m) => ({ value: m.key, label: m.label })),
    // Đang tải danh mục thì hiện tạm khoá; tải xong mà không có mới báo model đã tắt hoặc không còn.
    ...(value && !hop.some((m) => m.key === value)
      ? [{ value, label: q.isLoading ? value : t('cauHinhOcr.modelKhongDung', { khoa: value }) }]
      : []),
  ];
  return (
    <Select<string>
      {...p}
      className="w-full"
      showSearch
      optionFilterProp="label"
      loading={q.isLoading}
      placeholder={t('cauHinhOcr.fChonModelDoc')}
      value={value ?? (vai === 'dien' ? MAC_DINH : undefined)}
      onChange={(v) => onChange(v === MAC_DINH ? null : v)}
      options={options}
    />
  );
}

/** Tên model theo khoá để hiện trong bảng; `null` là model mặc định. */
export function useTenModel(): (key: string | null) => string {
  const { t } = useT();
  const q = useLuaChonModelAi();
  return (key) => (key ? (q.data?.find((m) => m.key === key)?.label ?? key) : t('ocr.modelMacDinh'));
}
